import { ElMessageBox } from 'element-plus'
import { readDisplayState } from '@/views/mobile/shared/displayState'

const listeners = new Set()
let sequence = 0

export function subscribeResponsiveDialog(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function isMobileLayout() {
  return readDisplayState().layoutMode === 'mobile'
}

function dispatch(payload) {
  if (!listeners.size) {
    if (payload.kind === 'prompt') return ElMessageBox.prompt(payload.message, payload.title, payload.options)
    if (payload.kind === 'alert') return ElMessageBox.alert(payload.message, payload.title, payload.options)
    return ElMessageBox.confirm(payload.message, payload.title, payload.options)
  }
  listeners.forEach(listener => listener(payload))
}

function openDrawer(kind, message, title, options = {}) {
  if (!isMobileLayout()) {
    if (kind === 'prompt') return ElMessageBox.prompt(message, title, options)
    if (kind === 'alert') return ElMessageBox.alert(message, title, options)
    return ElMessageBox.confirm(message, title, options)
  }

  return new Promise((resolve, reject) => {
    const fallback = dispatch({
      id: ++sequence,
      kind,
      message,
      title,
      options,
      resolve,
      reject
    })
    if (fallback && typeof fallback.then === 'function') return fallback.then(resolve, reject)
  })
}

export function responsiveConfirm(message, title, options = {}) {
  return openDrawer('confirm', message, title, options)
}

export function responsivePrompt(message, title, options = {}) {
  return openDrawer('prompt', message, title, options)
}

export function responsiveAlert(message, title, options = {}) {
  return openDrawer('alert', message, title, { ...options, showCancelButton: false })
}
